import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/task-state`)
  return data.data
}

export const useTaskStates = () => {
  const { data, ...props } = useQuery(
    queryKeys.TASK_STATES,
    () => getData(),
  )
  return { data, ...props }
}
